import SeoLandingPage from "@/components/SeoLandingPage";
import heroImage from "@/assets/kitchen-demolition.jpg";

const KitchenDemolition = () => (
  <SeoLandingPage
    slug="kitchen-demolition-wisconsin"
    metaTitle="Kitchen Demolition Contractors | Green Bay & De Pere, WI"
    metaDescription="Kitchen demolition in Green Bay, De Pere, Appleton, and Northeast Wisconsin. Cabinet, countertop, backsplash, flooring, and drywall removal with debris hauling."
    h1="Kitchen Demolition in Northeast Wisconsin"
    heroImage={heroImage}
    heroIntro="A clean remodel starts with a careful tear-out. We remove the old kitchen, protect the rest of your home, and leave the space ready for your next contractor."
    serviceName="Kitchen Demolition"
    bullets={[
      "Cabinet, island, pantry, and built-in removal.",
      "Countertop, backsplash, sink, and fixture removal after utilities are safely disconnected.",
      "Flooring, underlayment, drywall, and non-structural partition removal.",
      "Protection for floors, doorways, stairs, and rooms outside the work area.",
      "Debris loading, hauling, and responsible disposal.",
      "Broom-clean handoff for your carpenter, plumber, electrician, or remodeler.",
    ]}
    whyUs={[
      "One crew handles tear-out and hauling, eliminating a separate debris-removal step.",
      "Selective removal helps protect cabinets, trim, appliances, or flooring that will remain.",
      "Clear scope and written pricing based on your photos or an on-site walkthrough.",
      "Local service throughout De Pere, Green Bay, Appleton, and Northeast Wisconsin.",
    ]}
    processSteps={[
      { title: "Send project photos", detail: "Show us the kitchen, access route, and materials you want removed." },
      { title: "Confirm the tear-out scope", detail: "We identify what stays, what goes, utility responsibilities, site protection, and disposal needs." },
      { title: "Complete the demolition", detail: "The crew protects adjoining surfaces and removes the approved materials in a controlled sequence." },
      { title: "Clear the debris", detail: "We haul away demolition waste and leave the room broom-clean for the renovation team." },
    ]}
    faqs={[
      { q: "How much does kitchen demolition cost?", a: "Kitchen demolition cost depends on room size, materials, access, disposal weight, and whether flooring or drywall is included. Send photos for a written estimate based on your kitchen." },
      { q: "How long does kitchen demolition take?", a: "Many selective kitchen tear-outs can be completed in one to two working days. Larger kitchens, heavy tile, difficult access, or broader wall and floor removal can require more time." },
      { q: "Do you disconnect plumbing, gas, or electrical lines?", a: "Utilities must be safely shut off and disconnected by the appropriate qualified trade before demolition begins. We confirm those responsibilities in the written scope." },
      { q: "Can you save cabinets or fixtures for reuse?", a: "Sometimes. Tell us before the estimate which items you want preserved so we can assess whether careful removal is practical and include it in the scope." },
      { q: "Do you remove all kitchen demolition debris?", a: "Yes. Loading, hauling, and disposal are included when listed in your written estimate, and the work area is left broom-clean." },
    ]}
    ctaHeadline="Planning a kitchen remodel?"
  />
);

export default KitchenDemolition;
